import api from "./core";

const basePath = "api/{{serverSegment}}/Avatars";

export default {
  async downloadUrl(id) {
    const result = await api.get(
      `${basePath}/Download/${api.getToken()}/${id}`,
      {
        "Hide-Loading": true
      }
    );
    return result;
  }
};
